
import React, { useState } from "react";
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import CameraIcon from '@mui/icons-material/PhotoCamera';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Link as materialLink } from '@mui/material/Link';
import { Link, useNavigate } from 'react-router-dom';
import List from '@mui/material/List';
import { green, red, grey, purple } from '@mui/material/colors';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { PDFDownloadLink, Document, Page } from 'react-pdf/dist/esm/entry.webpack'
import resumePdf from "./TommasoFrambaResume2023.pdf";

function Copyright() {
  return (
    <Stack
    sx={{ pb: 1 }}
    direction="row"
    spacing={2}
    justifyContent="center"
  >
    {/* <Button variant="contained">Contact</Button> */}
    <Button variant="text" color="custom3" href="https://mail.google.com/mail/?view=cm&fs=1&to=frambatom@gmail.com">Email</Button>
    <Button variant="text" color="custom3" href="https://www.linkedin.com/in/tommaso-framba-a9a7a5199/">LinkedIn</Button>
    <Button variant="text" color="custom3" href="https://github.com/TommasoFramba">Github</Button>
  </Stack>
  );
}


const theme = createTheme({
  palette: {
    text: {
      primary: '#FAFAFA',
      secondary: '#BDBDBD',
    },
    background: {
      default: "#061b2b",
    },
    primary: {
      main: grey[900],
    },
    secondary: {
      main: green[500],
    },
    custom1: {
      light: "#ff6158",
      main: "#e7222e",
      contrastText: "#ffffff",
      dark: "#ac0006",
    },
    custom2: {
      light: "#5284bf",
      main: "#16588e",
      contrastText: "#ffffff",
      dark: "#002f60",
    },
    custom3: {
      light: "#5284bf",
      main: "#4b94cc",
      contrastText: "#ffffff",
      dark: "#002f60",
    }
  },
  neutral: {
    main: '#64748B',
    contrastText: '#fff',
  },
});

export default function About() {

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <main>
        {/* Hero unit */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"

          sx={{
            pt: 5,
            pb: 3,
          }}
        >
        </Box>
        <Container>

          <Typography
            variant="h4"
            align="center"
            color="text.primary"
            component="p"
          >
            About Tommaso Framba
          </Typography>
          <Typography
            variant="h5"
            align="left"
            color="text.primary"
            component="p"
            sx = {{
              pt: 2
            }}
          >
            Education
          </Typography>
          <Typography
            variant="p"
            align="left"
            color="text.secondary"
            component="p"
            sx = {{
              pt: 2
            }}
          >
            UC Santa Cruz Baskin Engineering - Graduated June 2022
          </Typography>
          <Typography
            variant="p"
            align="left"
            color="text.secondary"
            component="p"
          >
            B.S. in Computer Science
          </Typography>
          <Typography
            variant="h5"
            align="left"
            color="text.primary"
            component="p"
            sx = {{
              pt: 4
            }}
          >
            Employment Status: Available
          </Typography>
          <Typography
            variant="p"
            align="left"
            color="text.secondary"
            component="p"
            sx = {{
              pt: 2
            }}
          >
            New graduate from the University of California, Santa Cruz with a B.S. degree in Computer Science interested in full stack development with an emphasis on distributed backend systems that deal with realtime or relational databases. Also interested in new grad positions for Android/Flutter mobile development.
          </Typography>
          <Typography
            variant="h5"
            align="left"
            color="text.primary"
            component="p"
            sx = {{
              pt: 4
            }}
          >
            Tech Stack
          </Typography>
          <Typography
            variant="p"
            align="left"
            color="text.secondary"
            component="p"
            sx = {{
              pt: 2
            }}
          >
            Proficient Langs/Frameworks: Java/Kotlin, Dart/Flutter, C/C++, Python, PostgreSQL/MySQL
          </Typography>
          <Typography
            variant="p"
            align="left"
            color="text.secondary"
            component="p"
          >
            Proficient IDEs/Tools: Docker, Android Studio, IntelliJ, Visual Studio/Code 
          </Typography>
          <Typography
            variant="p"
            align="left"
            color="text.secondary"
            component="p"
          >
          Proficient OS: Android, iOS, Unix, Windows 
          </Typography>
          <Typography
            variant="p"
            align="left"
            color="text.secondary"
            component="p"
          >
          Prior Experience: React, Go, Swift, Objective C, AWS, Google Cloud functions 
          </Typography>
          <Typography
            variant="h5"
            align="left"
            color="text.primary"
            component="p"
            sx = {{
              pt: 4
            }}
          >
            Interests/Hobbies
          </Typography>
          <Typography
            variant="p"
            align="left"
            color="text.secondary"
            component="p"
            sx = {{
              pt: 2
            }}
          >
            In my free time I enjoy to surf, watch Formula 1, and am passionate about creating mobile applications for all platforms however I strongly prefer Android. Another passion of mine is dismantling/fixing anything mechanical, especially if it has four wheels, a manual transmission, and an engine.    
          </Typography> 

        </Container>
      </main>
      {/* Footer */}
      <Box sx={{ bgcolor: 'primary', p: 6 }} component="footer">
        <Typography variant="h6" align="center" gutterBottom>
          Contact
        </Typography>
        
        <Copyright />
        <Typography variant="body2" color="text.secondary" align="center">
      {'Copyright © '}
      <materialLink color="inherit" href="https://github.com/TommasoFramba">
        Tommaso Framba
      </materialLink>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
      </Box>
      {/* End footer */}
    </ThemeProvider>
  );
}